import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
import { forYouPoints } from '../../data/forYou';
export function ForYou() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-88" data-mp="2tasppah0r7b5">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-89" data-mp="3gzbxlow5pi2p">
        <SectionTag icon="👀" data-id="element-90" data-mp="3h03hi2ge5rd5">Esto es para ti si…</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-91" data-mp="3l16zovlwvzhj">
          ¿Te suena alguna de estas escenas?
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-92" data-mp="3c08q7xspezrk">
          Si te identificas con 2 o más, MISTER PRO fue diseñado exactamente para ti.
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-93" data-mp="1vobvie3l19tm">
        {forYouPoints.map((point, i) => <m.div key={point.n} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="relative flex flex-col rounded-2xl border border-white/10 bg-bg-primary p-6" data-id="element-94" data-mp="3pall4kn864rz" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-95" data-mp="3uazvwag7nstp">
              <span className="font-heading text-3xl font-bold text-white/10" data-id="element-96" data-mp="c1phafepmg36">{point.n}</span>
              <span className="text-2xl" aria-hidden="true" data-id="element-97" data-mp="80nhnxgvs20o">
                {point.emoji}
              </span>
            </div>
            <span className="mt-3 inline-block w-fit rounded-full bg-lime/10 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-lime" data-id="element-98" data-mp="luxzduugmvx8">
              {point.tag}
            </span>
            <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-white" data-id="element-99" data-mp="vox0cqiss9nl">
              {point.title}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-muted" data-id="element-100" data-mp="xvmuml2rcbiv">{point.text}</p>
            <div className="mt-4 flex h-6 w-6 items-center justify-center rounded-full bg-success/15" data-id="element-101" data-mp="12ty3ashbgfzi">
              <CheckIcon size={14} className="text-success" data-id="element-102" data-mp="17tkekwdl3m5o" />
            </div>
          </m.div>)}
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 text-center sm:px-6" data-id="element-103" data-mp="1ckapsq8oyj8a">
        <p className="text-base leading-relaxed text-white sm:text-lg" data-id="element-104" data-mp="1hjdsi4178dd3">
          Entrena con la seguridad de quien llega al campo sabiendo exactamente qué quiere trabajar, cómo
          corregirlo y cómo conectarlo con el próximo partido.
        </p>
        <div className="mt-6 flex justify-center" data-id="element-105" data-mp="1qkbmdthxb4hy">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-106" data-mp="1vin0igf9415z">Quiero organizar mis sesiones</PrimaryButton>
        </div>
      </div>
    </section>;
}